import { reduce, transform } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '@src/components/SectionTitle';
import api from '@src/util/api';
import SkillsSection from './SkillsSection';
import './styles.scss';

function setOptionToState(activeSkills, option, lastPickedSection, isMandatory = false) {
  return {
    activeSkills: { ...activeSkills, [option.id]: { ...option, isMandatory } },
    lastPickedSection,
  };
}

export default class Skills extends Component {
  static propTypes = {
    activeSkills: PropTypes.arrayOf(PropTypes.object).isRequired,
    setSkills: PropTypes.func.isRequired,
    specialityKey: PropTypes.string.isRequired,
  };

  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      activeSkills: this.transformActiveSkills(props.activeSkills),
      lastPickedSection: '',
      skillSections: [],
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state !== nextState || this.props !== nextProps;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.specialityKey !== this.props.specialityKey) {
      this.fetchSkills();
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchSkills();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  transformActiveSkills = activeSkills => {
    return reduce(
      activeSkills,
      (result, _skill) => {
        const { isMandatory, skill } = _skill;
        result[skill.id] = { ...skill, isMandatory };
        return result;
      },
      {},
    );
  };

  fetchSkills = async () => {
    const { activeSkills, specialityKey } = this.props;

    api(`/api/skills/${specialityKey}`).then(({ skills }) => {
      if (this._isMounted) {
        this.setState({ activeSkills: this.transformActiveSkills(activeSkills), skillSections: skills });
      }
    });
  };

  setSkills = () => {
    const { setSkills } = this.props;
    const { activeSkills } = this.state;

    setSkills(
      transform(
        activeSkills,
        (result, value) => {
          const { isMandatory, ...skill } = value;
          delete skill.section;
          result.push({ _id: skill.id, isMandatory, skill });
          return result;
        },
        [],
      ),
    );
  };

  selectImportance = (_option, lastPickedSection, isMandatory) => {
    const option = { ..._option, section: lastPickedSection };

    this.setState(({ activeSkills }) => {
      return setOptionToState(activeSkills, option, lastPickedSection, isMandatory);
    }, this.setSkills);
  };

  selectSkill = (_option, lastPickedSection) => {
    const option = { ..._option, section: lastPickedSection };

    this.setState(({ activeSkills }) => {
      const id = option.id;

      if (activeSkills[id]) {
        // remove from state
        const { [id]: removed, ..._activeSkills } = activeSkills;

        return { activeSkills: _activeSkills, lastPickedSection };
      }

      return setOptionToState(activeSkills, option, lastPickedSection);
    }, this.setSkills);
  };

  render() {
    const { skillSections, activeSkills, lastPickedSection } = this.state;

    return (
      <div className="skills">
        {skillSections.map(skillSection => {
          return (
            <div key={skillSection.tag}>
              <SectionTitle subtitle={skillSection.subtitle} title={skillSection.question} />

              <SkillsSection
                activeSkills={activeSkills}
                lastPickedSection={lastPickedSection}
                section={skillSection}
                selectImportance={this.selectImportance}
                selectSkill={this.selectSkill}
              />
            </div>
          );
        })}
      </div>
    );
  }
}
